import React, { useContext, useEffect, useRef, useState } from "react";

import {
  AppBar,
  Box,
  Portal,
  styled,
  Toolbar,
  Typography
} from '@mui/material';
import UsderMenu from "./UserMenu";

import logoSrc from './logo2.png';
import { useAppDispatch } from "../../hooks/redux";
import { actions as statActions } from '../../services/stats';
import { actions as traitActions } from '../../services/traits';

const ImgLogo = styled('img')({
  width: 120,
});

const AppFrameContext = React.createContext({
  titleRef: null
});

const AppFrame: React.FC = ({ children }) => {
  const dispatch = useAppDispatch();
  const ref = useRef(null);
  const [ refState, setRefState ] = useState(null);

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    setRefState(ref.current)
    
  }, []);

  useEffect(() => {
    dispatch(statActions.load());
    dispatch(traitActions.load());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AppFrameContext.Provider value={{ titleRef: refState }}>
      <Box sx={{ display: 'flex' }}>
        <AppBar elevation={1} position="fixed">
          <Toolbar>
            <Box sx={{ mr: 3 }}>
              <ImgLogo src={logoSrc} />
            </Box>
            <Typography variant="h6" noWrap component="div" ref={ref} sx={{ flexGrow: 1, ml: 3 }}>
            </Typography>
            <UsderMenu />
          </Toolbar>
        </AppBar>
        <Box
          component="main"
          sx={{ flexGrow: 1 }}
        >
          <Toolbar />
          {children}
        </Box>
      </Box>
    </AppFrameContext.Provider>
  );
};

export default AppFrame;


interface AppFrameTitleProps {
  title: string;
}

export const AppFrameTitle: React.FC<AppFrameTitleProps> = ({ title }) => {
  const context = useContext(AppFrameContext);
  return (
    <Portal container={context.titleRef}>
      {title}
    </Portal>
  )
}